export default "__VITE_ASSET__CugUfWYV__"